<script>
const { VUE_APP_API_HOST } = process.env 

export default {
  methods: {
    list(){
      return this.$http
        .get(`${VUE_APP_API_HOST}/subscriptions/invoices`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          }
        )
        .then(res => res, err => err)
    },
    listInvoices(){
      return this.$http
        .get(`${VUE_APP_API_HOST}/subscriptions/invoices`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`}
          }
        )
        .then(res => res, err => err)
    }
  }
}
</script>